var application;

(function ($) {

	$(document).ready(function () {

		$(window).setBreakpoints({
			distinct: true,
			breakpoints: [
				768
			]
		});

		var mobileLoaded = false;
		if(scent.global.isMobile()) {
			mobileLoaded = true;
		}

		viewportDetection();

		$('img.hide-on-desktop').lazyload({
			threshold:200,
			load : function() {
				imageCenteringTeaserbox();
			}
		});
		$('img:not(.hide-on-desktop)').lazyload({
			threshold:600
		});


		$('.js-bottom .textbox .content h2').dotdotdot({
			watch: "window"
		});
		imageCentering();
		imageCenteringTeaserbox();
		articlenumberMargin();
		parallax();
		articleTitle();
		menuAnimation();
		editionNavLink();
		initQtip();

		setTimeout(function() {
			$('.js-bottom .textbox .content h2').trigger("update");
			imageCentering();
			imagecaption();
		}, 200);

		var $page = $('html');
		application = new Tc.Application($page);
		application.registerModules();
		application.start();

	});

	$(window).resize(function() {
		menuToggling();
		imageCentering();
		imageCenteringTeaserbox();
		parallax();
		articleTitle();
		viewportDetection();
	});

	function editionNavLink(){
		$('.header').on('click', '.link-editionnav, .menu-icon-dialog', function(e){
			var $this = $(this),
				$header= $('.header-edition-title'),
				$edition = $('.header-edition-title .het-edition'),
				$year = $('.header-edition-title .het-year');

			e.preventDefault();

			if ($this.hasClass('link-editionnav') && $this.hasClass('active')) {
				debug.log('editionNavLink > link0editionnav is used only for opening');
				return;
			}

			scrollToContent();

			$('.link-editionnav, .menu-icon-dialog').toggleClass('active');
			$('.mod-editionnavigation').toggleClass('hide', !$this.hasClass('active'));
			$('.mod-content, .mod-article, .mod-articleswitcher').toggleClass('hide', $this.hasClass('active'));
			if(!$this.hasClass('active')){
				$edition.html($header.data('edition'));
				$year.html($header.data('year'));
				scrollToContent();
				$('.mod-footer').css("margin-top", "0px");
			} else {
				$('.mod-footer').css("margin-top", "55px");
			}
		});
	}

	function scrollToContent() {

		var
			menuSize = 50,
			$navigation = $(".mod-editionnavigation"),
			$content = $('.mod-content'),
			scrollTo = $content.length > 0 ? $content.offset().top : 0;

		// consider weird top margin of navigation
		if($navigation.position().top <= menuSize ) {
			scrollTo -= menuSize; // assume we deduct a fixed size for the top menu
		}

		$('html, body').scrollTop(scrollTo);
	}

	function viewportDetection() {
		var viewport = document.getElementById('viewport') || $('meta[name=viewport]')[0];
		if(!viewport) {
			return;
		}
		if ( navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
			viewport.setAttribute("content", "width=device-width, initial-scale=1.0");
		} else if ( navigator.userAgent.match(/iPad/i) ) {
			if($(window).width() < $(window).height()) {
				viewport.setAttribute("content", "width=device-width, initial-scale=0.75");
			} else {
				viewport.setAttribute("content", "width=device-width, initial-scale=1.0");
			}
		}
	}

	function menuToggling() {
		var $mainmenuitem = $('.mainmenu > li').find('ul');
		if (scent.global.isMobile()) {
			$mainmenuitem.css("height", "");
			if($mainmenuitem.find('li').is(":visible")) {
				$mainmenuitem.find('li').hide();
			}
		} else {
			if(!$mainmenuitem.find('li').is(":visible")) {
				$mainmenuitem.find('li').show();
			}
		}
	}

	function imageCenteringTeaserbox() {
		var minors = $('.mod-newsitem.minor .imagewrapper');
		$('.col-1-3, .col-2-3, .col-4-12, .col-8-12, .col-1-2, .col-5-12, .col-7-12').find('.mod-newsitem:not(.main) .imagewrapper').add(minors).each(function imageCenteringTeaserbox() {
			if (scent.global.isMobile()) {
				var $image = $(this).find('img.hide-on-desktop');
				var height = $(this).height();
				var width = $(this).width();
				if(height > width) {
					$image.width(100);
					$image.css('height','auto');
					var margin = ($image.outerHeight()-100)/2;
					$image.css('margin-top', '-'+margin+'px');
				} else {
					$image.height(100);
					$image.css('width','auto');
					var margin = ($image.outerWidth()-100)/2;
					$image.css('margin-left', '-'+margin+'px');
				}
			}
		});
	}

	function imageCentering() {
		$('.mod-tagsearchresult').find('.imagewrapper').each(function imageCentering() {
			if (!scent.global.isMobile()) {
				var image = $(this).find('img.hide-on-mobile');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				if((height/width) < 0.9333) {
					image.width(300);
					image.css('height','auto');
					var margin = (image.outerHeight()-280)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.height(280);
					image.css('width','auto');
					var margin = (image.outerWidth()-300)/2;
					image.css('margin-left', '-'+margin+'px');
				}
			} else {
				var image = $(this).find('img.hide-on-desktop');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				var wrapperratio = 220/$(window).width();
				var imageratio = image.outerHeight()/image.outerWidth();
				if(imageratio > wrapperratio) {
					image.css('width',$(window).width());
					image.css('height','auto');
					var margin = (image.outerHeight()-220)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.css('height','220px');
					image.css('width','auto');
					var margin = (image.outerWidth()-$(window).width())/2;
					image.css('margin-left', '-'+margin+'px');
				}
			}
		});

		$('.mod-meta > .stagemedia .videocontainer').each(function imageCentering() {
			if (!scent.global.isMobile()) {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				if((height/width) > 0.39) {
					image.width(940);
					image.css('height','auto');
					var margin = (image.outerHeight()-370)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.height(370);
					image.css('width','auto');
					var margin = (image.outerWidth()-940)/2;
					image.css('margin-left', '-'+margin+'px');
				}
			} else {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				var wrapperratio = 120/$(window).width();
				var imageratio = image.outerHeight()/image.outerWidth();
				if(imageratio > wrapperratio) {
					image.css('width',$(window).width());
					image.css('height','auto');
					var margin = (image.outerHeight()-120)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.css('height','120px');
					image.css('width','auto');
					var margin = (image.outerWidth()-$(window).width())/2;
					image.css('margin-left', '-'+margin+'px');
				}
			}
		});

		$('.mod-article > .stagemedia .videocontainer').each(function imageCentering() {
			if (!scent.global.isMobile()) {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				if((height/width) > 0.47) {
					image.width(940);
					image.css('height','auto');
					var margin = (image.outerHeight()-440)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.height(440);
					image.css('width','auto');
					var margin = (image.outerWidth()-940)/2;
					image.css('margin-left', '-'+margin+'px');
				}
			} else {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				var wrapperratio = 200/$(window).width();
				var imageratio = image.outerHeight()/image.outerWidth();
				if(imageratio > wrapperratio) {
					image.css('width',$(window).width());
					image.css('height','auto');
					var margin = (image.outerHeight()-200)/4;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.css('height','200px');
					image.css('width','auto');
					var margin = (image.outerWidth()-$(window).width())/2;
					image.css('margin-left', '-'+margin+'px');
				}
			}
		});
	}

	function articlenumberMargin() {
		$("[class*='col-']").each(function articlenumberMargin() {
			$(this).find('div.articlenumber-spacer:first').css('height','0px');
		});
	}

	function imagecaption() {
		$('.imageleft, .imageright, .imagecenter').each(function imagecaption() {
			var img = $(this).find('img');
			var caption = $(this).find('.bildlegende');
			caption.outerWidth(img.width());
		});
	}

	function parallax() {
		$(window).scroll(function() {
			if (!scent.global.isMobile() && !(/iPhone|iPod|iPad/.test(navigator.userAgent))) {
				s = $(document).scrollTop();
				transformSlower = 'translateY('+(s/3)+'px)';
				$('.parallax img').css({
					'-webkit-transform':transformSlower,
					'-moz-transform':transformSlower,
					'-ms-transform':transformSlower,
					'-o-transform':transformSlower
				});
				moveUp = '-'+(s/3)+'px';
				$('.mod-article .col-5-12').css({
					'margin-top':moveUp
				});
			} else {
				$('.parallax img').css({
					'-webkit-transform':'',
					'-moz-transform':'',
					'-ms-transform':'',
					'-o-transform':''
				});
				$('.col-5-12').css({
					'margin-top':''
				});
			}
		});
	}

	function articleTitle() {
		$('.mod-article h1.fullwidth').each(function() {
			if (!scent.global.isMobile()) {
				if($(this).outerHeight() < 60) {
					$(this).css({'margin-top':'-117px'});
					$('.mod-article .spitzmarke.fullwidth').css({'margin-top':'-143px'});
				}
			} else {
				$(this).css({'margin-top':''});
				$('.mod-article .spitzmarke.fullwidth').css({'margin-top':''});
			}
		});
	}

	function initQtip() {

		var mod = this,
			$ctx = mod.$ctx;

		// module vars
		var QTIP_CONFIG = {
			position: {
				my: 'bottom center',
				at: 'top center',
				viewport: $(window), // Keep it on-screen at all times if possible
				adjust: {
					x: 0,
					y: -2
				}
			},
			hide: {
				fixed: true // Helps to prevent the tooltip from hiding occasionally when tracking!
				//,event : 'click' // Uncomment for styling and debugging
			},
			content: {
				title: false,
				text: function () {
					return $(this).data('hint');
				}
			},
			show: {
				event: 'click mouseenter'
			},
			style: {
				classes: ($.fn.qtip.defaults.style.classes || '') + ' scs-callout qtip-shadow qtip-rounded scs-form-qtip'
			}
		};

		$('form button.field-hint', $ctx).each(function () {
			var $buttonFieldHint = $(this);

			if ($buttonFieldHint.length !== 1 || typeof($buttonFieldHint.data('hint')) === 'undefined') {
				throw('Trying to create qtip instance on element without hint');
			}

			if (typeof($buttonFieldHint.data('qtip')) === 'undefined') {
				debug.log('Emagazine main.js > initialized Tooltip');
				$buttonFieldHint.qtip(QTIP_CONFIG);
			}

		});

	}

	function menuAnimation() {
		if($('.mod-splashscreen').length !== 0) {
			var menu = $('.mod-menu');
			if($(this).scrollTop() >= $(window).height()) {
				menu.css({
					'opacity' : 1.0,
					'margin-top' : 0 + 'px'
				});
			} else {
				menu.css({
					'opacity' : 0.0,
					'margin-top' : -40 + 'px'
				});
			}
			$(window).scroll(function() {
				var scrolltop = $(this).scrollTop();
				var startpoint = $(window).height()/2;
				if(scrolltop >= startpoint && scrolltop < $(window).height()) {
					menu.css({
						'opacity' : (scrolltop/startpoint - 1),
						'margin-top' : 40*(scrolltop/startpoint - 1)-40 + 'px'
					});
				} else if(scrolltop >= $(window).height()) {
					menu.css({
						'opacity' : 1.0,
						'margin-top' : 0 + 'px'
					});
				} else {
					menu.css({
						'opacity' : 0.0,
						'margin-top' : -40 + 'px'
					});
				}

			});
		} else {
			$('.mod-menu').css({
				'opacity' : 1.0,
				'margin-top' : 0 + 'px'
			});
		}
	}

	/*! Backstretch - v2.0.4 - 2013-06-19
	 * http://srobbin.com/jquery-plugins/backstretch/
	 * Copyright (c) 2013 Scott Robbin; Licensed MIT */
	(function(a,d,p){a.fn.backstretch=function(c,b){(c===p||0===c.length)&&a.error("No images were supplied for Backstretch");0===a(d).scrollTop()&&d.scrollTo(0,0);return this.each(function(){var d=a(this),g=d.data("backstretch");if(g){if("string"==typeof c&&"function"==typeof g[c]){g[c](b);return}b=a.extend(g.options,b);g.destroy(!0)}g=new q(this,c,b);d.data("backstretch",g)})};a.backstretch=function(c,b){return a("body").backstretch(c,b).data("backstretch")};a.expr[":"].backstretch=function(c){return a(c).data("backstretch")!==p};a.fn.backstretch.defaults={centeredX:!0,centeredY:!0,duration:5E3,fade:0};var r={left:0,top:0,overflow:"hidden",margin:0,padding:0,height:"100%",width:"100%",zIndex:-999999},s={position:"absolute",display:"none",margin:0,padding:0,border:"none",width:"auto",height:"auto",maxHeight:"none",maxWidth:"none",zIndex:-999999},q=function(c,b,e){this.options=a.extend({},a.fn.backstretch.defaults,e||{});this.images=a.isArray(b)?b:[b];a.each(this.images,function(){a("<img />")[0].src=this});this.isBody=c===document.body;this.$container=a(c);this.$root=this.isBody?l?a(d):a(document):this.$container;c=this.$container.children(".backstretch").first();this.$wrap=c.length?c:a('<div class="backstretch"></div>').css(r).appendTo(this.$container);this.isBody||(c=this.$container.css("position"),b=this.$container.css("zIndex"),this.$container.css({position:"static"===c?"relative":c,zIndex:"auto"===b?0:b,background:"none"}),this.$wrap.css({zIndex:-999998}));this.$wrap.css({position:this.isBody&&l?"fixed":"absolute"});this.index=0;this.show(this.index);a(d).on("resize.backstretch",a.proxy(this.resize,this)).on("orientationchange.backstretch",a.proxy(function(){this.isBody&&0===d.pageYOffset&&(d.scrollTo(0,1),this.resize())},this))};q.prototype={resize:function(){try{var a={left:0,top:0},b=this.isBody?this.$root.width():this.$root.innerWidth(),e=b,g=this.isBody?d.innerHeight?d.innerHeight:this.$root.height():this.$root.innerHeight(),j=e/this.$img.data("ratio"),f;j>=g?(f=(j-g)/2,this.options.centeredY&&(a.top="-"+f+"px")):(j=g,e=j*this.$img.data("ratio"),f=(e-b)/2,this.options.centeredX&&(a.left="-"+f+"px"));this.$wrap.css({width:b,height:g}).find("img:not(.deleteable)").css({width:e,height:j}).css(a)}catch(h){}return this},show:function(c){if(!(Math.abs(c)>this.images.length-1)){var b=this,e=b.$wrap.find("img").addClass("deleteable"),d={relatedTarget:b.$container[0]};b.$container.trigger(a.Event("backstretch.before",d),[b,c]);this.index=c;clearInterval(b.interval);b.$img=a("<img />").css(s).bind("load",function(f){var h=this.width||a(f.target).width();f=this.height||a(f.target).height();a(this).data("ratio",h/f);a(this).fadeIn(b.options.speed||b.options.fade,function(){e.remove();b.paused||b.cycle();a(["after","show"]).each(function(){b.$container.trigger(a.Event("backstretch."+this,d),[b,c])})});b.resize()}).appendTo(b.$wrap);b.$img.attr("src",b.images[c]);return b}},next:function(){return this.show(this.index<this.images.length-1?this.index+1:0)},prev:function(){return this.show(0===this.index?this.images.length-1:this.index-1)},pause:function(){this.paused=!0;return this},resume:function(){this.paused=!1;this.next();return this},cycle:function(){1<this.images.length&&(clearInterval(this.interval),this.interval=setInterval(a.proxy(function(){this.paused||this.next()},this),this.options.duration));return this},destroy:function(c){a(d).off("resize.backstretch orientationchange.backstretch");clearInterval(this.interval);c||this.$wrap.remove();this.$container.removeData("backstretch")}};var l,f=navigator.userAgent,m=navigator.platform,e=f.match(/AppleWebKit\/([0-9]+)/),e=!!e&&e[1],h=f.match(/Fennec\/([0-9]+)/),h=!!h&&h[1],n=f.match(/Opera Mobi\/([0-9]+)/),t=!!n&&n[1],k=f.match(/MSIE ([0-9]+)/),k=!!k&&k[1];l=!((-1<m.indexOf("iPhone")||-1<m.indexOf("iPad")||-1<m.indexOf("iPod"))&&e&&534>e||d.operamini&&"[object OperaMini]"==={}.toString.call(d.operamini)||n&&7458>t||-1<f.indexOf("Android")&&e&&533>e||h&&6>h||"palmGetResource"in d&&e&&534>e||-1<f.indexOf("MeeGo")&&-1<f.indexOf("NokiaBrowser/8.5.0")||k&&6>=k)})(jQuery,window);

})(Tc.$);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/main.js
// module id = 32
// module chunks = 0